import React, { Component } from 'react'

import Razdel from '../block/Razdel'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data || {}

    return (
      <>
        <Razdel data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App